/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-02-25T16:21:58.316
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import BasicLayout from '@/layouts/basic-layout';

const meta = {
auth: true
};

const pre = 'rentmanage-renthousefacility-'

export default 
{
path: '/rentmanage/renthousefacility',
name: 'rentmanage-renthousefacility',
redirect: {
name: '${pre}-index'
}
,

meta:{
...meta,
},

component: BasicLayout ,
children:
[
{
path: 'index',
name: '${pre}renthousefacility-index',

meta:{
...meta,
title: '房源设施'
},

component: () => import('@/pages/rentmanage/renthousefacility/index') ,
},
{
path: 'detail-edit/:id',
name: '${pre}renthousefacility-detail-edit',
auth: [
'hidden'
],

meta:{
...meta,
title: '房源设施编辑'
},

component: () => import('@/pages/rentmanage/renthousefacility/detail-edit') ,
},
{
path: 'detail-edit',
name: '${pre}renthousefacilitydetail-create',
auth: [
'hidden'
],

meta:{
...meta,
title: '房源设施新增'
},

component: () => import('@/pages/rentmanage/renthousefacility/detail-edit') ,
},
{
path: 'detail-view/:id',
name: '${pre}renthousefacilityView',
auth: [
'hidden'
],

meta:{
...meta,
title: '房源设施详情查看'
},

component: () => import('@/pages/rentmanage/renthousefacility/detail-view') ,
},
]
};
